import { render, staticRenderFns } from "./TodoCard.vue?vue&type=template&id=f0037ca4&scoped=true"
var script = {}
import style0 from "./TodoCard.vue?vue&type=style&index=0&id=f0037ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0037ca4",
  null
  
)

export default component.exports